<template>
  <div>
    <el-button size="mini" @click="openPopup" :disabled="disabled">대상 선택</el-button>
    <w-sliding-popup :type="popupType" ref="slidingPopup" title="관리 대상 선택" width="1200px" @open="open" @close="close">
      <div slot="content">
        <w-check-obj-table ref="checkObjTable" :active="active" :type="type" :checked-obj-list="objList"
        :managetype-data="managetypeData" :selected-managetype-id="selectedManagetypeId" :vm-template-flag="vmTemplateFlag" :show-interface-column="showInterfaceColumn"
        :show-netdevice-selection="showNetdeviceSelection" @change-obj-list="changeObjList"
        :except-define-ids="exceptDefineIds" :except-objtype-ids="exceptObjtypeIds" :obj-define-ids="objDefineIds" :objtype-ids="objtypeIds" :hiddenNetdeviceChildren="hiddenNetdeviceChildren"/>
      </div>
      <div slot="footer">
        <el-button size="large" type="solid" @click="clickApplyButton">적용</el-button>
        <el-button size="large" @click="closePopup">취소</el-button>
      </div>
    </w-sliding-popup>
  </div>
</template>

<script>
import { isNil, cloneDeep } from 'lodash';
import WCheckObjTable from '@/components/table/CheckObjTable/index';

export default {
  name: 'WCheckObjTablePopupButton',
  components: {
    WCheckObjTable,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    // 논리:logical/물리:physical/논리-물리:both 테이블을 구분하는 변수
    type: {
      type: String,
      default: 'both',
    },
    // 기존에 선택된 관리대상 리스트
    checkedObjList: {
      type: Array,
      default: () => [],
    },
    // 제외할 objDefineId들을 배열로 정의한다
    exceptDefineIds: {
      type: Array,
      default: () => [],
    },
    // 제외할 objtypeId들을 배열로 정의한다.
    exceptObjtypeIds: {
      type: Array,
    },
    // 필터링할 objDefineId들을 배열로 정의한다.
    objDefineIds: {
      type: Array,
    },
    // 필터링할 objtypeId들을 배열로 정의한다.
    objtypeIds: {
      type: Array,
    },
    // 물리테이블 : 물리 테이블 영역의 관리구분 리스트, 따로 지정해주지 않으면 activeManagetypesToShow를 사용
    managetypeData: {
      type: Array,
      default: () => [],
    },
    // 물리테이블 : 물리 테이블 영역에서 특정 managetypeId만을 보여준다
    selectedManagetypeId: {
      type: String,
      default: null,
    },
    // 물리테이블
    vmTemplateFlag: {
      type: String,
      default: null,
    },
    // 물리테이블 : 권한관련 설정에서는 인터페이스가 필요가 없기때문에 인터페이스 컬럼을 보여주지 않는다
    showInterfaceColumn: {
      type: Boolean,
      default: true,
    },
    // 네트워크 장비를 부모로 가지는 관리 대상 숨김 여부
    hiddenNetdeviceChildren: {
      type: Boolean,
      default: false,
    },
    // 물리테이블 : 물리테이블에서 인터페이스 대상만을 선택하기 위한 변수 (selectedManagtypeId = "NMS" 로 하고 showNetdeviceSelection = false로 한다)
    showNetdeviceSelection: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      popupType: null,
      active: false,
      objList: [],
    };
  },
  methods: {
    open() {
      this.active = true;
      this.objList = cloneDeep(this.checkedObjList);
    },
    close() {
      this.active = false;
      this.$refs.checkObjTable.initData();
    },
    changeObjList(objList, flag) {
      objList.forEach((obj) => {
        if (flag) {
          const addObj = this.objList.find((item) => item.objId === obj.objId);
          if (isNil(addObj)) {
            this.objList.push(obj);
          }
        } else {
          const deleteObj = this.objList.find((item) => item.objId === obj.objId);
          if (!isNil(deleteObj)) {
            this.objList.splice(this.objList.indexOf(deleteObj), 1);
          }
        }
      });
    },
    openPopup() {
      this.popupType = this.$store.state.common.showSettingView ? 'setting' : 'common';
      this.$refs.slidingPopup.open();
    },
    closePopup() {
      this.$refs.slidingPopup.close();
    },
    clickApplyButton() {
      this.$emit('change-obj-list', this.objList);
      this.closePopup();
    },
    clickCancelButton() {
      this.closePopup();
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/button/CheckObjTablePopupButton.vue